<button
  class="button button--{{type}} button--padding-{{padding}}"
  (click)="handleClick($event)"
  [ngClass]="{
    'button--loading': loading,
    'button--disabled': disabled
  }"
  >
  @if (loading) {
    <div class="loading-container">
      <ui-spinner
        p-size="25"
      ></ui-spinner>
    </div>
  }

  <ng-content>
  </ng-content>
</button>